<template>
    <div>
        <div class="content-container ">
            <div class="title-container text-white p-2">
                <p class="text-center fs-1 m-1">
                    Country Risk and Opportunity Platform<br/>
                </p>
                <p class="text-center fs-4 m-1">
                    operated by TAC ECONOMICS for Veolia purposes<br/>
                </p>
            </div>
        </div>
        <div class="justify-content-center m-2 intro-container">
            <p class="intro text-center fs-4 m-1">
                <br/><br/>This platform assesses the Economic & Business, Geopolitical & Political, Social & Societal and Environmental situation of 184 countries.
            </p>
            <p class="intro text-center fs-4 m-1">
            It also provides an opportunity measure and offers the possibility to cross risk and opportunity.
            </p>
            <p class="intro text-center fs-4 m-1">
            It is built on <b>external data</b> only and provides an <b>external perception of the risks and opportunities</b>.
            </p>
            <p class="intro text-center fs-4 m-1">
            Country risks can impact the multifaceted performance or the operations of any company.
            </p>
        </div>

        <div class="search-bar-container container d-flex justify-content-center align-items-center mx-auto col">
            <ul class="resultats mb-0 bg-white border border-1 border-white col-12 col-lg-10 opacity-1">
                <li class="searchBox">
                    <input
                    class="border border-0"
                    v-model="searchTerm"
                    placeholder="Search for a country or an indicator"
                    @click.stop
                    @keyup.enter="performSearch"
                    />
                </li>
                <li
                    v-for="(item, index) in filteredCountries"
                    :key="index"
                    :class="{ active: selectedIndex === index }"
                    @click="new_selected(item)"
                    > {{ item[0] }}
                </li>
            </ul>
        </div>

        <div v-if="showDisclaimer" class="disclaimer-popup d-flex justify-content-center align-items-center align-self-center fixed-top w-100 h-100">
            <div class="modal d-flex align-items-center justify-content-center w-100 h-100">
                <div class="header text-white text-center flex-column align-items-center justify-content-center fs-3 p-4 pt-3">
                    <h2>Disclaimer</h2>
                    <div class="content bg-white text-black w-100 h-100 d-flex flex-column align-items-center justify-content-center text-center fs-4 m-0 px-3 py-4">
                        <p>The Country Risk Platform offers a perception of country risk as perceived by major international institutions and/or globally recognized research centers.<br><br>
                        It expresses long term &b in systemic gross risk. This platform is based on open source data and is updated every 6 months. Therefore, it does not capture current or one-off events.<br><br>
                        The ratings provided by the tool do not supersede the operational experience of our on-site collaborators and/or the opinions and analyses of experts from our functional departments (e.g., Security Department, Compliance, etc.).<br><br>
                        We, therefore, encourage you to contact the appropriate department in case of suspected risk.</p>
                        <button class="button-disclaimer text-white border border-0 fs-5 mt-3 px-4 py-1" @click="acceptDisclaimer">Understood</button>
                    </div>
                </div>
            </div>
        </div>
        
        <div id="tabs" class="d-flex flex-row flex-center mt-4">
            <div v-for="tab in tabs" :key="tab.name">
                <button
                :class="['rounded-3 mx-2 btn', selectedTab === tab.name ? 'btn-secondary' : 'btn-light']"
                style="height: 90px; width: 150px; padding: 0.5rem"
                @click="selectedTab = tab.name"
                >
                <p style="font-size: 20px; margin: 0;" class="text-center">
                    <span class="material-icons">{{ tab.icon }}</span>
                </p>
                <p style="font-size: 12px; margin: 0;" class="text-center">
                    {{ tab.nameDisplay }}
                </p>
                </button>
            </div>
        </div>


        <div v-if="Object.keys(mapRisk).length > 0 && selectedTab == 'glocntrrisk'">
            <CountryRiskMap :map="mapRisk" :title="titleRisk" :subtitle="subtitleRisk" />
        </div>

        <div v-if="Object.keys(mapOpportunity).length > 0 && selectedTab == 'opportunity'">
            <CountryOpportunityMap :map="mapOpportunity" :title="titleOpportunity" :subtitle="subtitleOpportunity" />
        </div>

        <div style="height:80vh" v-if="unifiedData.length > 0 && selectedTab == 'opvsglorisk'">
            <OpportunityVSGlobalCountryRisk :id="'opvsglorisk'" :chartData="unifiedData" />
        </div>
    </div>
</template>

<script> 
/* eslint-disable */
import CountryRiskMap from '../components/HomePage/CountryMap.vue'
import CountryOpportunityMap from '../components/HomePage/CountryOpportunityMap.vue'
import OpportunityVSGlobalCountryRisk from '@/components/HomePage/OpportunityVSGlobalCountryRisk.vue'
import api from '@/services/api'
import IndicatorRiskName from "./app.json"
import IndicatorOpportName from "./app_opport.json"


import { useStore } from 'vuex';
import { countryToAlpha2 } from "country-to-iso";
import { array } from '@amcharts/amcharts5'

export default {
    computed: {
        showDisclaimer() {
            return this.$store.state.showDisclaimer;
        },
    },
    components: {
        CountryRiskMap,
        CountryOpportunityMap,
        OpportunityVSGlobalCountryRisk
    },
    data () {
        return {
            mapRisk: {},
            mapOpportunity: {},
            unifiedData: [],
            selectedC: '',
            drapeauUrl: '',
            titleRisk: 'Global Country Risk Assessment',
            subtitleRisk: 'Consolidation of 4 pillars: Economic & Business, Political & Geopolitical, Social & Societal and Environmental <strong>(data updated every 6 months)</strong>',
            titleOpportunity: 'Global Country Opportunity Assessment',
            subtitleOpportunity: 'Consolidation of 4 pillars: Macro, Waste, Water and Energy (data updated every 6 months)',
            country: [],
            data: [],
            searchTerm: '',
            filteredCountries: this.country,
            selectedIndex: -1,

            tabs: [
                {name: 'glocntrrisk', nameDisplay: 'Risk', icon:'public'},
                {name: 'opportunity', nameDisplay: 'Opportunity', icon:'lightbulb'},
                {name: 'opvsglorisk', nameDisplay: 'Opportunity vs Risk', icon:'balance'},
            ],
            selectedTab: 'glocntrrisk',
            countryRegionData: [],

        }
    },
    methods: {
        modifyCountryToAlpha2(countryIdOrName) {
            const originalCountryToAlpha2 = countryToAlpha2;
            if ((countryIdOrName === 'KSV') | (countryIdOrName === 'Kosovo')) {
                return 'XK';
            } else {
                return originalCountryToAlpha2(countryIdOrName);
            }
        },
        acceptDisclaimer() {
            this.$store.commit('acceptDisclaimer');
        },
        new_selected(array) {
            if (array[1] == 'country') {
                this.$router.push(`/country/${array[0]}`)
            } else {
                this.$router.push(`/indicator/${array[2]}`)
            }
        },
        performSearch() {
            const searchTermLower = this.searchTerm.toLowerCase();
            const foundItem = this.filteredCountries.find(item => item[0].toLowerCase() === searchTermLower);
            if (foundItem) {
                this.new_selected(foundItem);
            }
        },
        handleKeyPress(event) {
            console.log("this.filteredCountries",this.filteredCountries)
            if (event.key === 'ArrowUp') {
                this.selectedIndex = Math.max(this.selectedIndex - 1, 0);
            } else if (event.key === 'ArrowDown') {
                if (Array.isArray(this.filteredCountries) && this.filteredCountries.length > 0) {
                this.selectedIndex = Math.min(this.selectedIndex + 1, this.filteredCountries.length - 1);
                }
            } else if (event.key === 'Enter' && this.selectedIndex !== -1) {
                this.new_selected(this.filteredCountries[this.selectedIndex]);
            } else if (event.key === 'Escape') {
                this.filteredCountries = [];
                this.selectedIndex = -1;
            }
        },
        handleClickOutside(event) {
            const menuContainer = document.querySelector('.search-bar-container');

            // Check if the menuContainer exists and the click is outside of it
            if (menuContainer && !menuContainer.contains(event.target)) {
                this.filteredCountries = [];
                this.selectedIndex = -1;
            }
        },

        async getData() {
            try {
                const results = await api.get('/countryprofile/ALLCNT?page=home_page')
                const countries = await api.get('/countries?cnttype=REG_LIMITED')
                const data = results.data.data
                const countriesData = countries.data.data

                const filteredRisk = data.filter(d =>
                    d.symbol === "overallcountryrisk" || d.symbol === "opport"
                );
                
                const groupedRisk = {};
                filteredRisk.forEach(item => {
                    if (!groupedRisk[item.country_id]) {
                        groupedRisk[item.country_id] = {};
                    }
                    groupedRisk[item.country_id][item.symbol] = item.value;
                });

                const regionColors = {
                    "Asia & Oceania": "#e74c3c",
                    "Europe": "#4287f5",
                    "North Africa & Middle East": "#6d0c70",
                    "North America": "#3ce7e7",
                    "South & Central America": "#067d4d",
                    "Sub-Saharan Africa": "#b69259",
                };

                this.unifiedData = countriesData.map(country => {
                    const risks = groupedRisk[country.country_id] || {};
                    return {
                        country_id: country.country_id,
                        country_name: country.country_name,
                        region_name: country.region_name,
                        overallcountryrisk: risks["overallcountryrisk"] || null,
                        opport: risks["opport"] || null,
                        color: country.isoperation === 1
                            ? regionColors[country.region_name] || "#bdc3c7"
                            : "#bdc3c7",
                        isActive: country.isoperation,
                        isoperation: country.isoperation,
                    };
                });

                this.mapOpportunity = {};
                this.unifiedData.forEach((obj) => {
                    this.mapOpportunity[obj.country_id] = {
                        name: this.modifyCountryToAlpha2(obj.country_id),
                        opportunity: obj.opport,
                    };
                });

                
                this.mapRisk = {};
                this.unifiedData.forEach((obj) => {
                    this.mapRisk[obj.country_id] = {
                        name: this.modifyCountryToAlpha2(obj.country_id),
                        risk: obj.overallcountryrisk,
                    };
                });
            } catch(error) {
                console.error('Erreur lors de la récupération des données:', error);
            }
        },



        async getCountries() {
            try {
                const response = await api.get('/countries');
                const data = response.data;
                this.country = data.data.map(item => [item.country_name, 'country']);
                this.getDataFromJson()
            } catch (error) {
                console.error('Erreur lors de la récupération des pays :', error);
            }
        },
        async selectedCountry() {
            this.selectedC = this.$route.params.element;
        },
        getDataFromJson() {
            for (const key in this.data) {
                if (this.data.hasOwnProperty(key)) {
                    const item = this.data[key];
                    const all_code = item.code.split('/')
                    const raw_code = all_code[all_code.length - 1];
                    const itemArray = [item.description, 'indicator', raw_code];
                    this.country.push(itemArray);
                }
            }
        },
        filterCountries() {
          if (this.searchTerm.trim() === '') {
            this.filteredCountries = [];
          } else {
            // this.filteredCountries = this.country.filter((item) =>
            // item[0].toLowerCase().includes(this.searchTerm.toLowerCase())
            let intermediary = this.country.filter((item) =>
                item[0].toLowerCase().includes(this.searchTerm.toLowerCase())
            );
            this.filteredCountries = this.removeDuplicateArrays(intermediary)
        }
      },
      removeDuplicateArrays(arrays) {
        const seen = new Set();
        return arrays.filter(array => {
            const serialized = JSON.stringify(array);
            if (seen.has(serialized)) {
            return false;
            }
            seen.add(serialized);
            return true;
        });
}
    },
    watch: {
      searchTerm() {
        this.filterCountries();
      },
    },
    created() {
        document.body.addEventListener('click', this.handleClickOutside);
    },
    async mounted() {

        this.data = IndicatorOpportName.concat(IndicatorRiskName)
        
        await this.getData();
        await this.getCountries();
        this.selectedCountry();
        const response = await api.get('/countries');
        this.countryRegionData = response;
        document.addEventListener('keydown', this.handleKeyPress);
        
    },
    destroyed() {
        document.removeEventListener('keydown', this.handleKeyPress);
        document.body.removeEventListener('click', this.handleClickOutside);
    },
}
</script>

<style scoped>

span.material-icons {
    font-size: xx-large
}

</style>